
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artikkel/[slug]",
      function () {
        return require("private-next-pages/artikkel/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artikkel/[slug]"])
      });
    }
  